module.exports = __webpack_public_path__ + "assets/img/title-4d910120.png";